import config from '../../config/config';
import { createQueryParams, setIf } from '@nexio/emvio-util-app';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';
import { goToUrl } from '../Table/tableActions';

export const PENDING_PAYOUTS_LOAD = 'PENDING_PAYOUTS/PENDING_PAYOUTS_LOAD';
export const PENDING_PAYOUTS_SUCCESS = 'PENDING_PAYOUTS/PENDING_PAYOUTS_SUCCESS';
export const PENDING_PAYOUTS_FAILURE = 'PENDING_PAYOUTS/PENDING_PAYOUTS_FAILURE';

export const DELETE_PENDING_PAYOUTS_LOAD = 'PENDING_PAYOUTS/DELETE_PENDING_PAYOUTS_LOAD';
export const DELETE_PENDING_PAYOUTS_SUCCESS = 'PENDING_PAYOUTS/DELETE_PENDING_PAYOUTS_SUCCESS';
export const DELETE_PENDING_PAYOUTS_FAILURE = 'PENDING_PAYOUTS/DELETE_PENDING_PAYOUTS_FAILURE';

export const fetchUrl = `${config.payoutApiUrl}`;

export function getPendingPayouts(filters, page, pageSize, sorters, payoutAccountIds, columns) {
    const queryParamsString = createQueryParams({
        filters,
        payoutAccountIds,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: getPendingPayoutsFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}/pending${queryParamsString}`
        },
        loadActionTypeOrCreator: PENDING_PAYOUTS_LOAD,
        successActionTypeOrCreator: getPendingPayoutsSuccessActionCreator
    };
}

export function selectPendingPayoutsFromBatches(history, providerId, currency, batchRef) {
    goToUrl(history, `/pending-payout/${batchRef}/${providerId}/${currency}`);
}

export function getPendingPayoutsSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, PENDING_PAYOUTS_SUCCESS, 'pendingPayouts');
}

export function getPendingPayoutsFailureActionCreator(error) {
    return {
        error,
        type: PENDING_PAYOUTS_FAILURE
    };
}

export function deletePendingPayouts({ pendingPayoutIds, batchRef, currency, providerId }) {
    const body = {};

    setIf(body, 'ids', pendingPayoutIds);
    setIf(body, 'batchRef', batchRef);
    setIf(body, 'currency', currency);
    setIf(body, 'providerId', providerId);

    return {
        failureActionTypeOrCreator: deletePendingPayoutsFailureActionCreator,
        fetchParams: {
            body,
            method: 'DELETE',
            url: `${fetchUrl}/pending`
        },
        loadActionTypeOrCreator: DELETE_PENDING_PAYOUTS_LOAD,
        successActionTypeOrCreator: deletePendingPayoutsSuccessActionCreator
    };
}

export function deletePendingPayoutsFailureActionCreator(error) {
    return {
        error,
        type: DELETE_PENDING_PAYOUTS_FAILURE
    };
}

export function deletePendingPayoutsSuccessActionCreator() {
    return {
        type: DELETE_PENDING_PAYOUTS_SUCCESS
    };
}
